// extracted by mini-css-extract-plugin
export var activeFilters = "_jg-2";
export var container = "_jg-0";
export var emptyState = "_jg-4";
export var list = "_jg-3";
export var toolbar = "_jg-1";